<template>
  <el-dialog
    title="设置代理"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="mini"
    >
      <el-form-item
        prop="legal"
        label="微信呢称"
      >
        {{userName}}
      </el-form-item>
      <el-form-item
              prop="legal"
              label="姓名"
      >
        {{legal}}
      </el-form-item>
      <el-form-item
        prop="fd"
        label="账号福豆"
      >
          {{fd}}

      </el-form-item>
        <el-form-item
                prop="accountType"
                label="类型"
                :rules="[{ required: true, message: '不能为空'}]"
        >
            <el-select
                    v-model="form.accountType"
                    placeholder="请选择"
                    class="search-input"
            >
                <el-option
                        v-for="item in typeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="福豆" prop="prov_cd"  :rules="[{ required: true, message: '不能为空'}]">
            <el-input v-model="form.prov_cd"></el-input>
        </el-form-item>





        <el-form-item>
      <el-button
              type="primary"
              :loading="loading"
              @click="saveUser"
      >保存</el-button>
      <el-button @click="close">取消</el-button>
    </el-form-item>
    </el-form>
  </el-dialog>

</template>
<style>
  .customWidth{
    width:80%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js';
export default {
  name: "twoagentyEditForm",
  props: {
      oneagent: Object,
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
        userName:"",
      legal:"",
        fd:"",
      agenttype:"",
      dl_type:"",
        shop_agentid:"",
      form: {
          accountType:"",
          prov_cd:""
      },
        typeOptions: [ {
            value: "1",
            label: "加福豆"
        },{
            value: "0",
            label: "减福豆"
        }]
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {

    dialogOpen() {
      this.$refs.form.resetFields();
      if (this.oneagent.userId) {

          this.userName = this.oneagent.userName;
        this.legal = this.oneagent.legal;
        this.agenttype= this.oneagent.agenttype;
        this.dl_type=this.oneagent.dl_type;
          this.shop_agentid=this.oneagent.shop_agentid;
          this.fd=this.oneagent.is_fd;
      } else {
        this.form = {};
      }

    },
      saveUser() {
          this.$refs["form"].validate(valid => {
              if (valid) {
                  if (this.oneagent.userId) {
                      this.loading = true;
                      agentService.saveShDltype({ ...this.form,agentid:this.oneagent.agentid,dl_gl:this.oneagent.dl_type,kkk:3,shop_id:util.cookies.get('agentid')})
                          .then(data => {
                              this.loading = false;
                              this.dialogVisible = false;
                              this.$emit("submit");
                          });
                  }
              } else {
                  return false;
              }
          });
      },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

